import * as React from 'react';
const TabContext = /*#__PURE__*/React.createContext(null);
export default TabContext;